import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center gap-2" }

import { computed } from 'vue';
import FormRow from '@/components/Common/FormRow.vue';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'TripStartTimeRow',
  props: {
    modelValue: {},
    errorMessages: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const hours = Array.from({ length: 25 }, (_, i) => ({
  title: String(i).padStart(2, '0'),
  value: String(i).padStart(2, '0'),
}));

const minutes = [
  { title: '00', value: '00' },
  { title: '30', value: '30' },
];

const hour = computed({
  get: () => props.modelValue.split(':')[0] ?? '00',
  set: (val) => emit('update:modelValue', `${val}:${props.modelValue.split(':')[1] ?? '00'}`),
})

const minute = computed({
  get: () => props.modelValue.split(':')[1] ?? '00',
  set: (val) => emit('update:modelValue', `${props.modelValue.split(':')[0] ?? '00'}:${val}`),
})

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(FormRow, {
    title: _unref(i18n).global.t('pages.gpsTrackerSetting.tripStartTime'),
    required: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_select, {
          modelValue: hour.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hour).value = $event)),
          items: _unref(hours),
          "item-title": "title",
          "item-value": "value",
          "hide-details": "",
          clearable: false,
          style: {"max-width":"100px"}
        }, null, 8, ["modelValue", "items"]),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mx-1" }, ":", -1)),
        _createVNode(_component_v_select, {
          modelValue: minute.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((minute).value = $event)),
          items: minutes,
          "item-title": "title",
          "item-value": "value",
          "hide-details": "",
          clearable: false,
          style: {"max-width":"100px"}
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(ValidationErrors, { messages: __props.errorMessages }, null, 8, ["messages"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})